import PropTypes from "prop-types";
import React from "react";
import Check from "../../../assets/assets/check-circle.svg";

const Trail = (props) => {
  const {
    kitDownloadStatus,
    selectType,
    selectIntTypeStatus,
    uploadFinishStatus,
    ipFormStatus,
    publicKeyStatus,
    runTestStatus,
    docApproval,
    ipPermitApproval,
    testApproval,
  } = props;

  return (
    <div className="nip-trail">
      <div className="nip-trail-section">
        <div
          className={
            kitDownloadStatus
              ? "nip-trail-section-box2"
              : "nip-trail-section-box"
          }
        >
          <h1>Implementation Kit</h1>
          <p>Download NIP Implementation Kit</p>
          <div className="bottom">
            {!kitDownloadStatus && !uploadFinishStatus ?
              <div className="circle"></div> :
              !kitDownloadStatus && uploadFinishStatus ? (
                <div className="green-circle"></div>
              ) : (
                  kitDownloadStatus && (
                    <div className="check-circle">
                      <img src={Check} alt="check" />
                    </div>
                  )
                )}
          </div>
        </div>

        <div
          className={
            kitDownloadStatus && selectIntTypeStatus
              ? "nip-trail-section-box2"
              : "nip-trail-section-box"
          }
        >
          <h1>Select Integration Type</h1>
          <p>Select an integration type from the options provided</p>
          <div className="bottom">
            {!selectType && !kitDownloadStatus ? (
              <div className="circle"></div>
            ) : kitDownloadStatus && !selectIntTypeStatus ? (
              <div className="green-circle"></div>
            ) : (
                  selectIntTypeStatus &&
                  kitDownloadStatus && (
                    <div className="check-circle">
                      <img src={Check} alt="check" />
                    </div>
                  )
                )}
          </div>
        </div>

        <div
          className={
            selectIntTypeStatus && uploadFinishStatus
              ? "nip-trail-section-box2"
              : "nip-trail-section-box"
          }
        >
          <h1>Document Upload</h1>
          <p>Upload all necessary document for easy check</p>

          <div className="bottom">
            {!uploadFinishStatus && !docApproval ? (
              <div className="circle"></div>
            ) : uploadFinishStatus && !docApproval ? (
              <div className="green-circle"></div>
            ) : (
                  uploadFinishStatus &&
                  docApproval && (
                    <div className="check-circle">
                      <img src={Check} alt="check" />
                    </div>
                  )
                )}
          </div>
        </div>

        <div
          className={
            ipFormStatus ? "nip-trail-section-box2" : "nip-trail-section-box"
          }
        >
          <h1>IP Permit Form</h1>
          <p>NCS VPN IP address request Form</p>
          <div className="bottom">
            {!ipFormStatus && !ipPermitApproval ? (
              <div className="circle"></div>
            ) : ipFormStatus && !ipPermitApproval ? (
              <div className="green-circle"></div>
            ) : (
                  ipFormStatus &&
                  ipPermitApproval && (
                    <div className="check-circle">
                      <img src={Check} alt="check" />
                    </div>
                  )
                )}
          </div>
        </div>

        <div
          className={
            publicKeyStatus ? "nip-trail-section-box2" : "nip-trail-section-box"
          }
        >
          <h1>Share Public Keys</h1>
          <p>Provide public keys for access to run live integration</p>
          <div className="bottom">
            {!publicKeyStatus && !ipPermitApproval ? (
              <div className="circle"></div>
            ) : publicKeyStatus && !ipPermitApproval ? (
              <div className="green-circle"></div>
            ) : (
                  publicKeyStatus &&
                  ipPermitApproval && (
                    <div className="check-circle">
                      <img src={Check} alt="check" />
                    </div>
                  )
                )}
          </div>
        </div>

        <div className={testApproval ? "nip-trail-section-box4" : "nip-trail-section-box3"}>
          <h1>Run Test</h1>
          <p>Run live integration test</p>
          <div className="bottom">
            {!runTestStatus && !testApproval ? (
              <div className="circle"></div>
            ) : runTestStatus && !testApproval ? (
              <div className="green-circle"></div>
            ) : (
                  runTestStatus &&
                  testApproval && (
                    <div className="check-circle">
                      <img src={Check} alt="check" />
                    </div>
                  )
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

Trail.propTypes = {
  docApproval: PropTypes.any,
  docUploadStatus: PropTypes.any,
  ipFormStatus: PropTypes.any,
  ipPermitApproval: PropTypes.any,
  kit: PropTypes.any,
  kitDownloadStatus: PropTypes.any,
  migrationApproval: PropTypes.any,
  publicKeyStatus: PropTypes.any,
  runTestStatus: PropTypes.any,
  scheduleMigrationStatus: PropTypes.any,
  selectIntTypeStatus: PropTypes.any,
  selectType: PropTypes.any,
  testApproval: PropTypes.any,
  trail: PropTypes.any,
  uploadFinishStatus: PropTypes.any,
  uploadStartStatus: PropTypes.any
}



export default Trail;
